
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { ActivityIndicator, FlatList, Image, ScrollView, View } from 'react-native';
import { Icon } from 'react-native-elements';
import { useDispatch, useSelector } from 'react-redux';
import Colors from '../../constants/Colorsv2';
import { Text, TouchableOpacity } from '../../globalComponents/NativeOverrides';
import { market_getOrderFiltersByPlayerId, market_updatePlayerFilter } from '../../store/actionsv1/markets';
import { PublicPlayerProps } from '../../store/types/auth_svc';
import { PlayerFilterProps } from '../../store/types/mk_svc';


export const PlayerFiltersScreen = ({ navigation, route }:any) => {
    const [ filter_state, setFilterState ] = useState({
        loading: false
    })
    const dispatch = useDispatch()

    //Redux
    const player:PublicPlayerProps|undefined = useSelector((state:any) => state.player.player, (left, right) => left?.player_id == right?.player_id)
    const player_filters:PlayerFilterProps[] = useSelector((state:any) => state.market.player_filters.filter(pf => pf.status != 'deleted'), (left, right) => {
        if(left.length !== right.length){ return false }
        let left_pinned = left.filter(l => l.pinned).length
        let right_pinned = right.filter(l => l.pinned).length
        if(left_pinned != right_pinned){ return false }
        return true
    })

    useEffect(() => {
        if(!player){ return }
        getDataFromServer(player.player_id)
    },[player?.player_id])

    const getDataFromServer = async(player_id:string) => {
        if(filter_state.loading){ return }
        setFilterState({ ...filter_state, loading:true })
        await dispatch(market_getOrderFiltersByPlayerId(player_id))
        setFilterState({ ...filter_state, loading:false })

    }

    const handlePinFilter = async(filter:PlayerFilterProps) => {
        await dispatch(market_updatePlayerFilter({ ...filter, pinned: !filter.pinned }))
    }

    const renderPlayerFilters = (data: {item:PlayerFilterProps, index:number}) => {
        return (
            <View style={{ padding:10, flexDirection:'row', justifyContent:'space-between', alignItems:'center', borderBottomWidth:1, borderColor:Colors.shades.shade600 }}>
                <TouchableOpacity style={{ padding:10 }} onPress={() => handlePinFilter(data.item)}>
                    <Icon size={20} name={data.item.pinned?'star':'star-outline'} type='ionicon' color={data.item.pinned?Colors.incentive.gold:Colors.brand.electric} />
                </TouchableOpacity>
                <View style={{ flex:1 }}>
                    <Text size={14} color={Colors.shades.black} weight='semibold'>{data.item.name}</Text>
                    {data.item.premium?
                    <Text style={{ marginTop:2 }} color={Colors.incentive.gold} size={12} weight='semibold'>PREMIUM ONLY</Text>
                    :<></>}
                </View>
                <View style={{ flexDirection:'row' }}>
                    <TouchableOpacity style={{ borderRadius:100, borderWidth:1, borderColor:Colors.brand.electric, padding:10, marginRight:5 }} onPress={() => navigation.push('ManageFilter', { player_filter_id:data.item.player_filter_id })}>
                        <Text style={{ paddingRight:10, paddingLeft:10 }} size={12} color={Colors.brand.electric} textAlign='center'>Edit</Text>
                    </TouchableOpacity>
                    {data.item.premium && player?.type != 'premium' ?
                    <TouchableOpacity style={{ borderRadius:100, backgroundColor:Colors.incentive.gold, padding:10}} onPress={() => navigation.navigate('AuthStack', { screen: 'Premium' })}>
                        <Icon style={{ paddingLeft:10, paddingRight:10 }} name='lock' color={Colors.shades.white} type='feather' size={16} />
                    </TouchableOpacity>
                    :
                    <TouchableOpacity style={{ borderRadius:100, backgroundColor:Colors.utility.success, padding:10}} onPress={() => navigation.push('BetMatch', { player_filter_id: data.item.player_filter_id })}>
                        <Text style={{ paddingRight:10, paddingLeft:10 }} size={12} color={Colors.shades.white} textAlign='center'>Run</Text>
                    </TouchableOpacity>
                    }
                </View>
            </View>
        )
    }

    return (
        <View style={{ flex:1, backgroundColor:Colors.shades.white }}>
            <ScrollView style={{ flex:1 }}>
                <View style={{ padding:20, backgroundColor:Colors.shades.shade100 }}>
                    <Text size={18} color={Colors.brand.midnight} weight='bold' textAlign='left'>BET MATCH FILTERS</Text>
                    <Text style={{ marginTop:5 }} size={14} color={Colors.brand.midnight} weight='regular'>Create rulesets to filter all open orders on BettorEdge.</Text>
                    
                    <View style={{ marginTop:10, flexDirection:'row', alignItems:'center', padding:10, borderRadius:8, backgroundColor:Colors.shades.shade600 }}>
                        <Icon name='star' type='feather' color={Colors.incentive.gold} size={20} /> 
                        <Text style={{ flex:1, marginLeft:20 }} size={14} color={Colors.brand.electric} weight='regular'>Select the star next to the filter to make it visible on the markets home screen.</Text>
                    </View>
                </View>
                <FlatList data={player_filters.sort((a,b) => moment(a.create_datetime).valueOf() - moment(b.create_datetime).valueOf())} renderItem={renderPlayerFilters} keyExtractor={(item) => item.player_filter_id.toString()} />
                {filter_state.loading ?
                <ActivityIndicator style={{ padding:40, alignSelf:'center' }} size='large' color={Colors.brand.midnight} />
                :<></>}
                {!filter_state.loading && player_filters.length == 0 ?
                <View style={{ padding:20 }}>
                    <Image
                        source={{ uri: 'https://res.cloudinary.com/hoabts6mc/image/upload/v1698862064/open_box_nryphw.png' }}
                        style={{ height:200, width:200, alignSelf:'center' }}
                        resizeMode='center'
                    />
                    <View style={{ borderRadius:8, backgroundColor:Colors.shades.shade600, margin:10, padding:10 }}>
                        <Text size={18} color={Colors.brand.midnight} weight='semibold' textAlign='center'>You do not have any created filters</Text>
                        {false ?
                        <TouchableOpacity style={{ margin:10, padding:15, backgroundColor:Colors.utility.success, borderRadius:8 }} onPress={() => alert('SHOW BET MATCH HELP TOUR')}>
                            <Text size={14} color={Colors.shades.white} weight='semibold' textAlign='center'>LEARN MORE!</Text>
                        </TouchableOpacity>
                        :<></>}
                    </View>
                </View>
                :<></>}
            </ScrollView>
            <View style={{ backgroundColor:Colors.shades.shade100 }}>
                {!filter_state.loading && ( player_filters.length  == 0 || player?.type == 'premium' ) ?
                <TouchableOpacity style={{ padding:13, margin:20, backgroundColor:Colors.brand.electric, borderRadius:22 }}
                    onPress={() => navigation.push('ManageFilter', {  })}>
                        <Text size={14} color={Colors.shades.white} weight='semibold' textAlign='center'>CREATE BET MATCH FILTER</Text>    
                </TouchableOpacity>
                : 
                <TouchableOpacity style={{ padding:13, margin:20, backgroundColor:Colors.incentive.gold, borderRadius:22, opacity: 0.5 }}
                    onPress={() => navigation.navigate('AuthStack', { screen: 'Premium' })}>
                        <Text size={14} color={Colors.shades.white} weight='semibold' textAlign='center'>Go Premium To Create Unlimited Filters</Text>    
                </TouchableOpacity>
                }
            </View>
        </View>
    )
}

export default PlayerFiltersScreen